// extracted by mini-css-extract-plugin
export default {"root":"HxyTX","rotate":"PURgf","center":"v704d","rotateOnCenter":"S9M3A"};